// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { ZoneAdmin_abstract } from './../abstract/SagaBase/ZoneAdmin_abstract';
export class ZoneAdmin extends ZoneAdmin_abstract {}
